/** @hidden */
export default async function JSONResponseHandler(response: Response) {
  const responseClone = response.clone();
  const responseText = await responseClone.text();
  try {
    const data = JSON.parse(responseText);
    return data;
  } catch (err) {
    if (((response.status / 100) | 0) === 2) {
      // 200-299
      return Promise.resolve({
        message: responseText
      });
    } else {
      return Promise.resolve({
        code: response.status,
        message: responseText,
        httpStatus: response.status,
        error: true
      });
    }
  }
}
